import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Paper } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SimpleDialogDemo from "../../../Modals/SimpleDialog";
import MonedaForm from "./MonedaForm";
import { esMonedaBase } from "./monedaLogic";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "20px",
    margin: "20px",
    textAlign: "left",
    minHeight: "200px",
    width: "100%",
    backgroundColor: "#e0e0e0",
  },
  itemCard: {
    padding: 15,
    margin: 10,
  },
  codigo: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    marginBottom: 8,
  },
  etiquetaBase: {
    color: "white",
    backgroundColor: "#ff4400",
    borderRadius: 12,
    padding: "2px 10px",
    fontSize: "0.75rem",
    marginLeft: 10,
  },
}));

export default function EventMonedaContainer() {
  const classes = useStyles();
  const registryConfiguration = useSelector(
    (state) => state.registry.registryConfiguration
  );
  const monedas =
    (registryConfiguration.configuracion &&
      registryConfiguration.configuracion.moneda) ||
    {};

  return (
    <Paper className={classes.paper}>
      <Grid container direction="row" alignItems="flex-start" spacing={2}>
        <Grid item xs={12}>
          <Typography gutterBottom variant={"h2"} component="h2">
            Monedas
          </Typography>
          <Typography gutterBottom variant={"body1"}>
            Define las monedas que puede usar un atleta al inscribirse y cuál
            es la moneda base del evento. El monto que se envía a la
            pasarela de pago siempre se calcula en pesos mexicanos usando el
            tipo de cambio de cada moneda.
          </Typography>
          <Typography gutterBottom variant={"body2"} style={{ fontWeight: "bold" }}>
            Si no configuras ninguna moneda aquí, el evento usa Pesos
            Mexicanos por defecto. Importante: los precios que capturaste en
            Productos y en Modalidades y categorías deben estar en la moneda
            base del evento — por ejemplo, si el Euro es la moneda base, esos
            precios deben estar en euros, no en pesos.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <SimpleDialogDemo buttonText={"Crear moneda"}>
            <MonedaForm monedas={monedas} />
          </SimpleDialogDemo>
        </Grid>

        {Object.keys(monedas).map((monedaKey) => {
          const moneda = monedas[monedaKey];
          return (
            <Grid item xs={12} sm={6} md={4} key={monedaKey}>
              <Paper className={classes.itemCard}>
                <Typography className={classes.codigo}>
                  {moneda.codigo}
                  {esMonedaBase(moneda) && (
                    <span className={classes.etiquetaBase}>BASE</span>
                  )}
                </Typography>
                <Typography variant="body2">{moneda.texto}</Typography>
                <Typography variant="body2">
                  1 {moneda.codigo} = {moneda.cambioAPeso} MXN
                </Typography>
                {!esMonedaBase(moneda) && (
                  <Typography variant="body2" color="textSecondary">
                    Tipo de cambio mostrado al atleta: {moneda.tipoCambio}
                  </Typography>
                )}
                <SimpleDialogDemo
                  buttonText={"Editar"}
                  icon={<EditIcon />}
                >
                  <MonedaForm
                    monedaKey={monedaKey}
                    moneda={moneda}
                    monedas={monedas}
                  />
                </SimpleDialogDemo>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Paper>
  );
}
